import { render, staticRenderFns } from "./DecidedOpportunities.vue?vue&type=template&id=325adb5a&scoped=true&"
import script from "./DecidedOpportunities.vue?vue&type=script&lang=js&"
export * from "./DecidedOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./DecidedOpportunities.vue?vue&type=style&index=0&id=325adb5a&prod&lang=css&"
import style1 from "./DecidedOpportunities.vue?vue&type=style&index=1&id=325adb5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325adb5a",
  null
  
)

export default component.exports